<template>
    <!-- Radio Buttons template for Form 1 -->
    <v-app>
        <div style="padding:10px; border-radius: 5px; background-color: #555; color: white;">
            {{ title }}
        </div>
        <br>
        <div class="content" v-for="(content,index) in contents" :key="content['id']">
            <strong>{{ section }}.{{ index + 1 }}</strong> {{ content.question }}
            <div class="inline">
                <v-radio-group row v-model="model_score[index]">
                    <v-radio 
                        @change="checkPart(index, scale.value)"
                        v-for="scale in scales" 
                        :key="scale['id']" 
                        :label="scale.label" 
                        :value="scale.value" 
                    ></v-radio>
                </v-radio-group>
                <p class="text-xs-left red--text" v-if="!isFilled && !model_score[index]">Please check this answer</p>
            </div>
            <div class="input-field">
                <v-text-field type="text" label="Comments" class="validate" v-model="model_comment[index]"></v-text-field>
            </div>
        </div>
    </v-app>
</template>
<script>
export default {
    props:['model_score','model_comment','section','contents', 'title'],
    data(){
        return{
            test: [],
            isFilled: true,
            scales:[
                {
                    label: "Yes",
                    value: 0
                },
                {
                    label: "No",
                    value: 1
                },
                {
                    label: "N/A",
                    value: 'NA'
                }
            ]
        }
    },
    methods:{
        checkPart(index, value){
            let affectedParts = this.$store.state.affectedParts;
            let parts = this.contents[index].parts;
            if(value == 1){
                if(parts.length == 1){
                    this.$store.commit('includePart', parts[0]);
                }
                else{
                    for(var x = 0; x < parts.length; x++){
                        this.$store.commit('includePart', parts[x]);
                    }
                }
            }
            else{
                if(parts.length == 1){
                    let index = affectedParts.indexOf(parts[0]);
                    this.$store.commit('removePart',index);
                }
                else{
                    for(var x = 0; x < parts.length; x++){
                        let index = affectedParts.indexOf(parts[x]);
                        this.$store.commit('removePart', index);
                    }
                }
            }
        }
    },
    mounted(){
        
    }
}
</script>


